import PropTypes from "prop-types"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import LhoHouseIcon from "../../images/icons/lho_house-104.png"
import { Drilldown, DrilldownItem, DrilldownList } from "../common"
import { referenceComparator } from "../common/Drilldown"
import { houseLabelFor, cityLabelFor } from "../common/presentationFormatters"
import { t } from "../../i18next"

export default class HousesDrilldown extends Component {
  static propTypes = {
    houses: PropTypes.arrayOf(PropTypes.object).isRequired,
    className: PropTypes.string,
  }

  render() {
    return (
      <Drilldown className={`lho-explorer-houses-drilldown ${this.props.className}`} title={t("lho.houses")}>
        <DrilldownList>
          {this.props.houses.sort(referenceComparator).map(house => (
            <DrilldownItem key={house.reference}>
              <Link to={`/lho/${house.reference}`}>
                <div className="icon-container">
                  <div className="icon">
                    <img className="icon-lho_house" alt="HA" src={LhoHouseIcon} />
                  </div>
                </div>
                <div className="info">
                  <div className="reference">{house.reference}</div>
                  <div className="description">{houseLabelFor(house)}</div>
                  <div className="city">{cityLabelFor(house.address)}</div>
                </div>
              </Link>
            </DrilldownItem>
          ))}
        </DrilldownList>
      </Drilldown>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/lho-explorer/HousesDrilldown.js